import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const BookIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6665 17.875C3.6665 17.2673 3.90795 16.6844 4.33772 16.2546C4.76749 15.8248 5.35038 15.5834 5.95817 15.5834H18.3332"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.95817 1.83337H18.3332V20.1667H5.95817C5.35038 20.1667 4.76749 19.9253 4.33772 19.4955C3.90795 19.0657 3.6665 18.4828 3.6665 17.875V4.12504C3.6665 3.51725 3.90795 2.93436 4.33772 2.50459C4.76749 2.07482 5.35038 1.83337 5.95817 1.83337V1.83337Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
